// extracted by mini-css-extract-plugin
export default {"common_input_styles":"AdministratorInformation_common_input_styles__3nQtC","uploadLabel":"AdministratorInformation_uploadLabel__FUfbQ"};